import './App.css';
import Footer from './components/Footer/Footer';
import Hero from './components/Hero/Hero';
import Join from './components/Join/Join';
import Plan from './components/Plan/Plan';
import Program from './components/Program/Program';
import Reason from './components/Reasons/Reason';
// import Testinomial from './components/Testinomial/Testinomial';
function App() {
  return (
    <div className="App">
      <Hero/>
      <Program/>
      <Reason/>
      <Plan/>
      {/* <Testinomial/> */}
      <Join/>
      <Footer/>
    </div>
  );
}

export default App;
